import { GENERIC } from '../../Actions/Generic/types';

export const initialState = {
  initialLoad:false,
  loading: false,
  successMessage: null,
  errorMessage: null,
  redirectTo: null,
  isHamburgerVisible: false,
  isSideMenuHidden: false,
  isAlertNotificationVisible: false,
  serverErrorMessage: false,
};

const genericReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case GENERIC.LOADING: {
      return {
        ...state,
        loading: true,
      }
    }
    case GENERIC.INIT_LOADING: {
      return {
        ...state,
        initialLoad: true,
      }
    }
    case GENERIC.STOP_INIT_LOADING: {
      return {
        ...state,
        initialLoad: false,
      }
    }

    case GENERIC.STOP_LOADING: {
      return {
        ...state,
        loading: false,
      }
    }

    case GENERIC.SUCCESS_TOAST: {
      const { message } = action;
      return {
        ...state,
        successMessage: message,
      }
    }

    case GENERIC.ERROR_TOAST: {
      const { message } = action;
      return {
        ...state,
        errorMessage: message,
      }
    }
    case GENERIC.INTERNAL_SERVER_ERROR: {
      const { serverErrorMessage } = action;
      return {
        ...state,
        serverErrorMessage,    
      }
    }
    case GENERIC.RESET_ALL_MESSAGES: {
      return {
        ...state,
        successMessage: null,
        errorMessage: null,
      }
    }

    case GENERIC.REDIRECT_ROUTE: {
      const { redirectTo } = action;
      return {
        ...state,
        redirectTo,
      }
    }

    case GENERIC.RESET_REDIRECT_ROUTE: {
      return {
        ...state,
        redirectTo: null,
      }
    }

    case GENERIC.SET_HAMBURGER_VISIBILITY: {
      return {
        ...state,
        isHamburgerVisible: action.visible,
      }
    }

    case GENERIC.MANAGE_SIDEMENU_VISIBILITY: {
      let { isSideMenuHidden } = action;
      return {
        ...state,
        isSideMenuHidden
      }
    }
      
    case GENERIC.ALERT_NOTIFICATION: {
      let { isAlertNotificationVisible, notification } = action;
      console.log(action);
      return {
        ...state,
        isAlertNotificationVisible,
        notification
      }
    }
      
    default: {
      return {
        ...state,
      }
    }
  }
};

export default genericReducer;
